import React from 'react';
import { useRouteError } from 'react-router-dom';
import Error from 'components/Error';

export default function SectionError() {
    const error = useRouteError();

    // If a 404 is caught, rethrow it so that the parent error
    // boundary can handle it and display it as a root error
    if (error.status === 404) {
        throw error;
    }

    return (
        <div id="route-error-section" data-testid="route-error-section">
            <Error error={error} />
        </div>
    );
}
